import type { AxiosInstance } from 'axios';

export interface GlobalSetting {
  id: string;
  key: string;
  value: unknown;
  updatedAt: string;
}

export function settingsEndpoints(http: AxiosInstance) {
  return {
    list: () => http.get<{ data: GlobalSetting[] }>('/admin/settings').then((r) => r.data.data),
    get: (key: string) =>
      http.get<{ data: GlobalSetting | null }>(`/admin/settings/${key}`).then((r) => r.data.data),
    upsert: (key: string, value: unknown) =>
      http.put<GlobalSetting>(`/admin/settings/${key}`, { value }).then((r) => r.data),
    delete: (key: string) => http.delete<void>(`/admin/settings/${key}`).then((r) => r.data),
  };
}

export type SettingsEndpoints = ReturnType<typeof settingsEndpoints>;
